module.exports = __webpack_public_path__ + "img/logo_navbar.fa16253a.png";